import React, { useState, useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter, useLocation, useHistory } from 'react-router-dom'
import { withTheme } from 'styled-components'
import moment from 'moment'

import { Modal, Tabs, Select, Dropdown, Menu } from 'antd'
import { CardContainer, FlexColumn } from '../../Reusable/Container'
import PageHeader from '../../Reusable/PageHeader'
import { LabeledInput } from '../../Reusable/Input'
import { apiPOSTReq } from '../../../Utils/api'
import { getBPAccountsWithAccess, getFeaturePerm } from '../../../Utils/util'
import { fetchBBHistory, fetchBBTransactions, normalizeAndSortHistory, fetchInternational } from '../../../Utils/bankingDataManager'
import { Text } from '../../Reusable/Text'
import { ErrorAlert } from '../../Reusable/Alert'
import { Button, TextButton } from '../../Reusable/Button'
import PendingTable from '../Reusable/PendingTable'
import FullScreenModal from '../../Reusable/FullScreenModal'

import InternationalTable from '../Reusable/InternationalTable'
import { FromAccountOption } from '../../Reusable/Option'
import { addDataToStore, BNK_SAVE_DATA } from '../../../Actions/actions'
import environment from '../../../environment'

// Images
import AccountNameModal from '../Reusable/AccountNameModal'
import ModalClose from '../../../Images/modal-close.png'
import ArrowRight from "../../../Images/arrow-right.png"
import RightArrow from "../../../Images/right-arrow.svg"
import { Image } from '../../Reusable/Image'

const { Option } = Select

const pageSize = 50;

const InternationalActivity = (props) => {
    const [accounts, setAccounts] = useState([])
    const [subAccounts, setSubAccounts] = useState([])
    const [account, setAccount] = useState()
    const [accountIndex, setAccountIndex] = useState(0)
    const [type, setType] = useState()
    const [pendingTransfers, setPendingTransfers] = useState([])
    const [postedTransfers, setPostedTransfers] = useState([])
    const [showAccountNameModal, setShowAccountNameModal] = useState(false)
    const [loadingPending, setLoadingPending] = useState(true)
    const [loadingPosted, setLoadingPosted] = useState(true)
    const [moreToLoad, setMoreToLoad] = useState(false)
    const [currentOptions, setCurrentOptions] = useState({})
    const [singleAccount, setSingleAccount] = useState()
    const [back, setBack] = useState(false)
    const [searchTerm, setSearchTerm] = useState('')
    const [paymentErrorCodes, setPaymentErrorCodes] = useState([])
    const [dropdownVisible, setDropdownVisible] = useState(false)
    const [showBatchUploadModal, setShowBatchUploadModal] = useState(false)
    const [fullScreenModalContent, setFullScreenModalContent] = useState(null)

    const { store } = props

    const location = useLocation()
    const history = useHistory()

    const manageAccounts = getBPAccountsWithAccess("Payments", { permType: "manage", getActiveAccounts: true })

    const { UAM } = store
    const isAionCustomerSupportUser = UAM.aionCustomerSupportUser

    const initialStatus = (location.state && location.state.fromErrorBanner) ? ['error', 'Rejected', 'denied_approval'] : null
    const initialFromDate = (location.state && location.state.fromErrorBanner) ? moment().subtract(7, 'days').format("YYYY-MM-DD") : null

    useEffect(() => {
        var Accounts = getBPAccountsWithAccess("Transactions", { getActiveAccounts: true })
        Accounts = Accounts || []
        setSingleAccount(Accounts.length === 1)
        setAccounts(Accounts)

        Accounts.forEach(acc => {
            fetchSubAccounts(acc.accountNumber)
        })

        if (location.state && location.state.account) {
            setAccount(location.state.account)
            setAccountIndex(location.state.accountIndex)
            setType(location.state.type)
            setBack(true)
        } else {
            if (Accounts.length > 0) {
                setAccount(Accounts[0])
            }
        }

        getPaymentErrorCodes()
    }, [])

    const fetchTransactions = (options) => {
        var { fromDate, toDate, searchStr, fromAmt, toAmt, railList, viewBy, filterType, filterValue, paymentStatus, source } = options

        var fetchOptions = {
            pagination: options.pagination, // || pagination
        }

        console.log('fetchTransactions fetchOptions1:', fetchOptions)

        if (searchStr && searchStr != '') fetchOptions.searchStr = searchStr
        if (fromDate) fetchOptions.fromDate = fromDate
        if (toDate) fetchOptions.toDate = toDate
        if (fromAmt) fetchOptions.fromAmt = fromAmt
        if (toAmt) fetchOptions.toAmt = toAmt
        if (railList) fetchOptions.railList = railList
        if (viewBy && searchStr && searchStr != '') fetchOptions.viewBy = viewBy
        if (filterType) fetchOptions.filterType = filterType
        if (filterValue) fetchOptions.filterValue = filterValue
        if (paymentStatus) fetchOptions.paymentStatus = paymentStatus
        if (source) fetchOptions.source = source

        fetchOptions.bankProvider = "CrossRiverBank"

        setLoadingPosted(true)

        setCurrentOptions(fetchOptions)
        fetchInternational(fetchOptions, (err, resp) => {
            try {
                if (err) throw new Error(err)
                console.log("InternationalActivity fetchData fetchBBTransactions fetchOptions", fetchOptions)
                console.log("InternationalActivity fetchData fetchBBTransactions resp", resp)

                const newData = fetchOptions.pagination.current > 1 ? postedTransfers.concat(resp.Transactions) : resp.Transactions

                setMoreToLoad(newData.length !== resp.internationalTransfersCount)
                setPostedTransfers(newData)

                if (!searchStr) {
                    props.dispatch(addDataToStore(BNK_SAVE_DATA, resp || {}))
                }
            } catch (error) {
                ErrorAlert({ description: error.message })
            } finally {
                setLoadingPosted(false)
            }
        })
    }

    const reFetchTransactions = () => {
        fetchTransactions(currentOptions)
    }

    const loadMoreActivity = () => {
        // setPagination({ pageSize: 10, current: pagination.current + 1 })
        currentOptions.pagination.current = currentOptions.pagination.current + 1
        fetchTransactions(currentOptions) // { account: accounts[selectedAccount], pagination: { pageSize: 10, current: pagination.current + 1 } })
    }

    const fetchSubAccounts = (accountNumber) => {
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getSubAccounts`, { "BankProvider": environment.bankProvider.crb }, { "BankProvider": environment.bankProvider.crb, "AccountNumber": accountNumber, "BusinessId": store.BusinessUniqueKey }, (err, resp) => {
            try {
                console.log("/bb/getSubAccounts", err, resp);
                const data = resp;
                if (data.result) {
                    if (err) throw new Error(err);
                    console.log('getSubAccounts', data.subAccounts)

                    if (data.subAccounts && data.subAccounts.length > 0) {
                        setSubAccounts(subAccounts.concat(data.subAccounts))
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getSubAccounts", error, err, resp);
            }
        })
    }

    const getPaymentErrorCodes = () => {
        apiPOSTReq(`${environment.bbBaseUrl}/bb/getPaymentErrorCodes`, { "BankProvider": environment.bankProvider.crb }, { "BankProvider": environment.bankProvider.crb, "BusinessId": store.BusinessUniqueKey }, (err, resp) => {
            try {
                console.log("/bb/getPaymentErrorCodes", err, resp);
                const data = resp;
                if (data.result) {
                    if (err) throw new Error(err);
                    console.log('getPaymentErrorCodes', data)

                    if (data.paymentErrorCodes && data.paymentErrorCodes.length > 0) {
                        const sortedData = data.paymentErrorCodes.sort((a, b) => {
                            const aValue = `${a.code} - ${a.description}`.toLowerCase(); // Convert to lowercase for case-insensitive comparison
                            const bValue = `${b.code} - ${b.description}`.toLowerCase();

                            if (aValue < bValue) {
                                return -1;
                            }
                            if (aValue > bValue) {
                                return 1;
                            }
                            return 0; // If they're equal
                        });

                        setPaymentErrorCodes(sortedData)
                    }
                } else {
                    throw Error(data.error || data.responseMessage || "Sorry we had trouble processing your request. Please try again later")
                }
            } catch (error) {
                console.log("ERRR getPaymentErrorCodes", error, err, resp);
            }
        })
    }

    return (
        <>
            <FlexColumn start>
                <FlexColumn between style={{ width: '100%', paddingBottom: 24, marginTop: 0 }}>
                    <InternationalTable
                        filter
                        showErrorFilters
                        rail={'ACH'}
                        transactionType
                        download
                        runningBalance
                        viewReturn
                        account={account}
                        accounts={accounts.concat(subAccounts)}
                        accountIndex={0}
                        fetchTransactions={fetchTransactions}
                        moreToLoad={moreToLoad}
                        onLoadMore={() => loadMoreActivity()}
                        padding='6px 0 0'
                        loading={loadingPosted}
                        data={postedTransfers}
                        setSearchTerm={setSearchTerm}
                        sharedSearchTerm={searchTerm}
                        showAccount={accounts.length > 1}
                        paymentErrorCodes={paymentErrorCodes}
                        ctaContent={props.ctaContent}
                        initialStatus={initialStatus}
                        initialFromDate={initialFromDate}
                        setFullScreenModalContent={setFullScreenModalContent}
                        reFetchTransactions={reFetchTransactions}
                    />

                </FlexColumn>

                <Modal
                    wrapClassName='account-name-modal'
                    visible={showAccountNameModal}
                    footer={null}
                    closable={false}
                    maskClosable={true}
                    width={776}
                    destroyOnClose={true}
                    onCancel={() => setShowAccountNameModal(false)}
                    closeIcon={<img width='24px' height='24px' src={ModalClose} />}
                >
                    <AccountNameModal onCancel={() => setShowAccountNameModal(false)} />
                </Modal>
            </FlexColumn>

            {
                fullScreenModalContent &&
                <FullScreenModal
                    onClick={() => { }}
                    content={fullScreenModalContent}
                    onClose={() => setFullScreenModalContent(null)}
                />
            }
        </>
    )
}

function mapStateToProps(state) {
    return {
        store: state.aionAppReducer,
        bankingStore: state.bankingAppReducer
    }
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTheme(InternationalActivity)))